import React from 'react';
import '../../css/confirmDialog.css';

let confirmCallback = null;

export const showConfirmDialog = (message, onConfirm, onCancel) => {
    if (confirmCallback) {
        confirmCallback({ show: true, message, onConfirm, onCancel });
    }
};

const ConfirmDialog = () => {
    const [dialogState, setDialogState] = React.useState({
        show: false,
        message: '',
        onConfirm: null,
        onCancel: null
    });

    React.useEffect(() => {
        confirmCallback = setDialogState;
        return () => {
            confirmCallback = null;
        };
    }, []);

    const handleConfirm = () => {
        if (dialogState.onConfirm) {
            dialogState.onConfirm();
        }
        setDialogState({ show: false, message: '', onConfirm: null, onCancel: null });
    };

    const handleCancel = () => {
        if (dialogState.onCancel) {
            dialogState.onCancel();
        }
        setDialogState({ show: false, message: '', onConfirm: null, onCancel: null });
    };

    if (!dialogState.show) return null;

    return (
        <div className="confirm-dialog-overlay" onClick={handleCancel}>
            <div className="confirm-dialog-container" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-dialog-header">
                    <h3>Confirmación</h3>
                </div>
                <div className="confirm-dialog-body">
                    <p>{dialogState.message}</p>
                </div>
                <div className="confirm-dialog-footer">
                    <button 
                        className="confirm-dialog-btn confirm-dialog-btn-cancel"
                        onClick={handleCancel}
                    >
                        Cancelar
                    </button>
                    <button 
                        className="confirm-dialog-btn confirm-dialog-btn-confirm"
                        onClick={handleConfirm}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
